import _ from 'lodash';
import moment from 'moment';
import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Button, Icon, Popup } from 'semantic-ui-react';
import {
    brands,
    contractNameOptions, dentistTypesOrtho,
    isActive,
    isActiveOptions,
    isActiveRoles,
    rampDateOptions,
    udaRoleOptions
} from '../../constants';
import { getFamilyPatientDetails, sendFamilyReport, sendReport } from '../../redux/modules/billing';
import {
    addRampSetup,
    getLockLogHistory,
    getPayData,
    getProductionMove,
    getRampSetup,
    getTimeOffRequestData,
    getUdrPermissions,
    hideErrorModal,
    selectAndDeselectLock,
    updateParams,
    updateRampSetup,
    getProviderPayOverrides,
    saveProviderPayOverride,
    deleteProviderPayOverride,
    deleteProviderPayOverrideByKey,
    getCrossReportTotals,
    computeAndSaveCrossReportTotals
} from '../../redux/modules/payReports';
import { isBlankNullOrUndefined } from '../../utils/validations';
import { getPracticeInfo, getPracticeList, getRegionList } from '../../redux/modules/practices';
import { getMultipleScheduleData } from '../../redux/modules/schedule';
import { getDoctorScheduleDays } from '../../redux/modules/timeoffRequests';
import { getEarningsSendingSetup } from "../../redux/modules/earningsSending";
import { getAllContractsForMultipleUsers } from '../../redux/modules/docs';
import ErrorModal from "../ErrorModal";
import EarningSending from '../EarningSending';
import GreaterOfContract from '../GreaterOfContractModal';
import Loading from '../Loading';
import HelpMark from '../ManageHelp/HelpMark';
import RampSetupModal from '../RampSetupModal';
import ReportStatus from './ReportStatus';
import CdpReportsTableByDentists from './CdpReportsTableByDentists';
import CdpReportsTableByPractice from './CdpReportsTableByPractice';
import LockHistoryModal from './lockByProviderModal';
import Legend from "../Legend";
import { getSageAccounts } from '../../redux/modules/sageAccounts'
import { getSupportUsersList } from "../../redux/modules/account";
import { dentistTypes } from "../../constants";
import { getProviderRates } from '../../redux/modules/providerRates';
import { getOrthoPayTotal } from '../../redux/modules/payReportsNDP';
import { isProviderOverBase, toArray } from './services';
import { BaseStatusModal } from './components';
import { mergeDrListByRoles } from '../../utils/commonutils';
import { withProviderDetail } from './services/providerDetail';

const initialFilters = {
    dentist: null,
    region: null,
    practiceName: null,
    contractType: [],
    isActive: isActiveOptions[1].value,
    brandName: [],
    role: udaRoleOptions[0].value,
    rampDate: rampDateOptions[0].value,
    daysType: null,
    payType: null,
    tedFilter: false,
    account: [],
    excludeAccount: [],
    notesReminder: null,
    supportUser: 'all',
    greaterOfCategory: [],
    customContract: null,
    lowCareByPractice: false,
    otherPracticeMakingBase: false,
    showLockedAtLeastOnePractice: false,
    highlightBaseStatus: false,
    workedHalfDay: false,
    enableBcareOverride: false
}


class CdpReports extends Component {

    constructor(props) {
        super(props);
        this.dentistsTableRef = createRef();
        localStorage.setItem("brandCDP", '');
        this.state = {
            table: 'dentist',
            LockHistoryModal: false,
            lockedProvidersModal: false,
            lockedProvidersModalData: null,
            selectedLock: null,
            lockedDoctorsArry: [],
            startDate: props.match.params.year && props.match.params.month ? moment(`${props.match.params.year}-${props.match.params.month}`, 'YYYY-MM').format('YYYY-MM-01') : moment().format('YYYY-MM-01'),
            endDate: props.match.params.year && props.match.params.month ? moment(`${props.match.params.year}-${props.match.params.month}`, 'YYYY-MM').endOf('month').format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD'),
            load: true,
            detailsModal: false,
            rampSetupModal: false,
            GreaterOfContractModal: false,
            cdpPayDentist: null, // fetched from backend after main data loads
            cdpPayOralSurgeon: null, // fetched from backend after main data loads
            cdpPayPediatric: null, // fetched from backend after main data loads
            orthoPayTotal: null, // fetched from backend after main data loads
            loadingCrossReportTotals: false, // loading state while fetching cross-report totals
            practicePriceList: false,
            regionList: false,
            regionPractices: {},
            practiceOptions: [],
            supportUserOptions: [],
            practiceAbbr: {},
            prodAdjWo: null,
            rampSetupFormEdit: false,
            GoxNonBillableCare: 0,
            rampSetupForm: {
                id: 0,
                patientVisits: null,
                productionThreshold: null,
            },
            expandableColumn: null,
            selectedDoctors: [],
            // View-only provider exclusions: [{ key, name }]. Held in memory only (cleared on reload).
            excludedProviders: [],
            lastExcludedProvider: null,
            providerValidationRecords: [],
            expandableRowLevel2: null,
            headerLabel: "Loading....",
            filters: initialFilters,
            lockProcessingFlag: {
                active: false,
                desc: null
            },
            isProviderSet: false,
            docUserId: null,
            isProdMove: false,
            basePercent: 0,
            baseAuditRows: [],
            baseAuditModalOpen: false,
            customContractPercent: 0,
            contractExists: {},
            sageAccounts: [],
            showFilters: false
        }

        if (!props.match.params.month) {
            this.changeMonthAndYear();
        }
    }

    setLockProcessingFlag = (slice) => this.setState({ lockProcessingFlag: slice });

    getProviderPayPairValues = () => {
        const reportData = this.props.billingData.groupByDoctorByPractice
        return reportData.reduce((obj, item) => {
            if (item && item.ABBR) {
                obj[(item.ABBR).toLowerCase()] = item.procBasedPay;
            }
            return obj;
        }, {})
    }

    handleSelectAll = (checked, dentistAbbrArr) => {
        this.setState({
            selectedDoctors: checked ? dentistAbbrArr : [],
            providerValidationRecords: this.getProviderPayPairValues()
        });
    }

    handleSelectDoctor = (e, ABBR) => {
        const abbr = ABBR.toLowerCase();
        const { selectedDoctors, providerValidationRecords } = this.state;
        const isSelected = selectedDoctors.includes(abbr);

        this.setState({
            selectedDoctors: isSelected ? selectedDoctors.filter(d => d !== abbr) : [...selectedDoctors, abbr],
            ...(providerValidationRecords && { providerValidationRecords: this.getProviderPayPairValues() })
        });
    }

    setExcludedProviders = (list) => {
        this.setState({ excludedProviders: list, lastExcludedProvider: null });
    }

    excludeProvider = (key, name) => {
        const { excludedProviders } = this.state;
        if (!key || excludedProviders.some(p => p.key === key)) return;
        const entry = { key, name };
        this.setState({ excludedProviders: [...excludedProviders, entry], lastExcludedProvider: entry });
    }

    undoLastExcludedProvider = () => {
        const { excludedProviders, lastExcludedProvider } = this.state;
        if (!lastExcludedProvider) return;
        this.setState({
            excludedProviders: excludedProviders.filter(p => p.key !== lastExcludedProvider.key),
            lastExcludedProvider: null
        });
    }

    changeMonthAndYear = () => {
        this.props.dispatch(updateParams(moment().format('MM'), moment().format('YYYY')));
    }

    showPracticeList = (val) => this.setState({ practicePriceList: val });

    async componentDidMount() {
        const { dispatch, params } = this.props;
        const { startDate, endDate } = this.state;

        this.getPracticesData();
        this.fetchRegions();
        this.fetchSupportUsersList();

        const { payParams, scheduleParams, filters, parameters } = this.generateParameters(params, startDate)
        dispatch(getEarningsSendingSetup('general')).then((result) => {
            const providerOrManager = (result.toProvider);
            this.setState({ isProviderSet: providerOrManager });
        });
        this.fetchData(payParams, scheduleParams, filters, parameters, startDate)
        dispatch(getLockLogHistory({ scheduleDate: [startDate, endDate] })).then(data => {
            this.setState({ lockedDoctorsArry: data })
        })
        dispatch(getSageAccounts()).then((res = []) => {
            const sageAcc = res.reduce((acc, item) => {
                if (!acc.some(i => i.accountNumber === item.accountNumber)) {
                    acc.push({ ...item, key: item.accountNumber, value: item.accountNumber, text: item.accountNumber + ' - '+ item.accountDescription });
                }
                return acc;
            }, []);
            this.setState({ sageAccounts: sageAcc });
        });
    }

    componentDidUpdate(prevProps) {
        var prevYear = prevProps.match.params.year;
        var prevMonth = prevProps.match.params.month;
        var currentYear = this.props.match.params.year;
        var currentMonth = this.props.match.params.month;

        // If URL month/year params changed, update state and re-fetch data
        if (prevYear !== currentYear || prevMonth !== currentMonth) {
            var newStartDate = currentYear && currentMonth ? moment(`${currentYear}-${currentMonth}`, 'YYYY-MM').format('YYYY-MM-01') : moment().format('YYYY-MM-01');
            var newEndDate = currentYear && currentMonth ? moment(`${currentYear}-${currentMonth}`, 'YYYY-MM').endOf('month').format('YYYY-MM-DD') : moment().endOf('month').format('YYYY-MM-DD');
            
            this.setState({ startDate: newStartDate, endDate: newEndDate });
            
            var payParams = {
                startDate: newStartDate,
                endDate: newEndDate,
                abbr: false,
                "filters": {
                    "dentistType": 2,
                    "years": moment(newStartDate).format('YYYY'),
                    "months": [moment(newEndDate).format('MM')],
                    "keyword": "",
                    "dentist": false
                },
                "sortBy": {},
                lock: {
                    action: null
                }
            };
            var scheduleParams = {
                "filters": {
                    "dentistType": 2,
                    "years": moment(newStartDate).format('YYYY'),
                    "months": [moment(newStartDate).format('MM')],
                    "keyword": "",
                    "dentist": false
                },
                "sortBy": {}
            };
            var filters = {
                archive: false,
                status: false,
                dentist: false,
                startDate: newStartDate,
                endDate: newEndDate,
                years: moment(newStartDate).format('YYYY'),
                months: [moment(newStartDate).format('MM')]
            };
            var parameters = {
                startDate: newStartDate,
                endDate: newEndDate,
                abbr: false,
                userId: []
            };
            
            // Pass objects to fetchData - it will stringify them internally
            this.fetchData(payParams, scheduleParams, filters, parameters, newStartDate);
            this.props.dispatch(getLockLogHistory({ scheduleDate: [newStartDate, newEndDate] })).then(data => {
                this.setState({ lockedDoctorsArry: data })
            });
        }
    }
    // fetch all contracts for multiple users
    fetchAllContractsForMultipleUsers = async () => {
        const { dispatch } = this.props;
        await dispatch(getAllContractsForMultipleUsers()).then(res => {
            this.setState({ contractExists: res })
        });
    }

    fetchData = (payParams, scheduleParams, filters, parameters, resultStartDate) => {
        scheduleParams = JSON.stringify(scheduleParams)
        payParams = JSON.stringify(payParams);
        filters = JSON.stringify(filters)
        let params = {
            startDate: resultStartDate,
            endDate: moment(resultStartDate).endOf('month').format('YYYY-MM-DD'),
            abbr: false,
        }
        params = JSON.stringify(params);

        const { dispatch, user } = this.props;

        if (user.scheduleDoctors) {
            parameters.userId = Object.keys(user.scheduleDoctors)
            dispatch(getMultipleScheduleData(null, parameters))
        }

        dispatch(getProviderRates(params)).then(res => {
            this.setState({ providerRates: res })
        });

        dispatch(getProviderRates(JSON.stringify({ startDate: resultStartDate, endDate: moment().add(10, 'year').format('YYYY-MM-DD') }))).then(res => {
            this.setState({ futureProviderRates: res });
        });


        Promise.all([
            dispatch(getPracticeList()),
            dispatch(getRampSetup()),
            dispatch(getPracticeInfo()),
            dispatch(getDoctorScheduleDays(scheduleParams)),
            dispatch(getTimeOffRequestData(filters)),
            dispatch(getPayData(payParams, this.props.saved ? 'current' : undefined, 'report')),
            dispatch(getUdrPermissions(payParams)),
            dispatch(getProductionMove(params)),
            dispatch(getProviderPayOverrides(moment(resultStartDate).format('YYYY-MM'))),
            this.fetchAllContractsForMultipleUsers(),
        ]).then(async () => {
            this.setState({
                load: false,
                loadingCrossReportTotals: true
            });
            this.setLockProcessingFlag({ active: false, desc: null })
            this.setState({
                startDate: resultStartDate,
                endDate: moment(resultStartDate).endOf('month').format('YYYY-MM-DD')
            });

            // Fetch pre-computed cross-report totals from database
            const startDateStr = resultStartDate;
            const endDateStr = moment(resultStartDate).endOf('month').format('YYYY-MM-DD');
            const queryParams = `startDate=${startDateStr}&endDate=${endDateStr}`;

            try {
                const result = await dispatch(getCrossReportTotals(queryParams));

                // If we got data from DB, use all cross-report totals (CDP and Ortho)
                if (result && result.data) {
                    this.setState({
                        cdpPayDentist: Number(result.data.cdpPayDentist || 0),
                        cdpPayOralSurgeon: Number(result.data.cdpPayOralSurgeon || 0),
                        cdpPayPediatric: Number(result.data.cdpPayPediatric || 0),
                        orthoPayTotal: Number(result.data.orthoPayTotal || 0),
                        loadingCrossReportTotals: false
                    });
                    console.log('[CdpReports] Fetched cross-report totals from DB:', {
                        cdpPayDentist: result.data.cdpPayDentist,
                        cdpPayOralSurgeon: result.data.cdpPayOralSurgeon,
                        cdpPayPediatric: result.data.cdpPayPediatric,
                        orthoPayTotal: result.data.orthoPayTotal
                    });
                } else {
                    this.setState({ loadingCrossReportTotals: false });
                }
            } catch (err) {
                console.error('[CdpReports] Error fetching cross-report totals:', err);
                this.setState({ loadingCrossReportTotals: false });
                // On error, compute and save current page values
                await this.computeAndSaveCdpTotals(startDateStr, endDateStr);
            }
        });
    }

    // Compute CDP totals from current page data and save to DB
    computeAndSaveCdpTotals = async (startDateStr, endDateStr) => {
        try {
            const { billingData } = this.props;
            let cdpDentist = 0, cdpOralSurgeon = 0, cdpPediatric = 0;

            if (billingData && billingData.groupByDoctorByPractice) {
                Object.keys(billingData.groupByDoctorByPractice).forEach(practiceKey => {
                    const practice = billingData.groupByDoctorByPractice[practiceKey];
                    Object.keys(practice).forEach(doctorKey => {
                        const doctor = practice[doctorKey];
                        const role = doctor.UDARole || '';
                        const amount = Number(doctor.procBasedPay || 0) + Number(doctor.teamContribution || 0);

                        if (role.indexOf('Dentist') !== -1 && role.indexOf('Pediatric') === -1) {
                            cdpDentist += amount;
                        } else if (role.indexOf('Oral Surgeon') !== -1) {
                            cdpOralSurgeon += amount;
                        } else if (role.indexOf('Pediatric') !== -1) {
                            cdpPediatric += amount;
                        }
                    });
                });
            }

            // Save CDP totals to DB via cron endpoint
            const savePayload = {
                startDate: startDateStr,
                endDate: endDateStr,
                cdpPayDentist: cdpDentist,
                cdpPayOralSurgeon: cdpOralSurgeon,
                cdpPayPediatric: cdpPediatric
            };

            console.log('\n===============================================');
            console.log('[CdpReports] *** FALLBACK: COMPUTED CDP TOTALS FROM PAGE DATA ***');
            console.log('===============================================');
            console.log('[CdpReports] Period: ' + startDateStr + ' to ' + endDateStr);
            console.log('[CdpReports] CDP Pay — Dentist:       $' + cdpDentist.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            console.log('[CdpReports] CDP Pay — Oral Surgeon:  $' + cdpOralSurgeon.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            console.log('[CdpReports] CDP Pay — Pediatric:     $' + cdpPediatric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            console.log('[CdpReports] Sending to backend for saving...');
            console.log('===============================================\n');

            await this.props.dispatch(computeAndSaveCrossReportTotals(savePayload));
            console.log('[CdpReports] Successfully saved CDP totals to DB:', savePayload);
        } catch (err) {
            console.error('[CdpReports] Error saving CDP totals:', err);
            // Non-critical, page still displays correctly
        }
    }

    onRefresh = async (saved) => {
        try {
            const { startDate, endDate } = this.state;
            this.setState({ load: true });
            const { payParams } = this.generateParameters(this.props.params, startDate);
            await this.props.dispatch(getPayData(JSON.stringify(payParams), saved, 'report'));
            this.setState({ load: false });
        } catch (error) {
            this.setState({ load: false });
        }
    }

    generateParameters = () => {
        return {
            scheduleParams: {
                "filters": {
                    "dentistType": 2,
                    "years": moment(this.state.startDate).format('YYYY'),
                    "months": [moment(this.state.startDate).format('MM')],
                    "keyword": "",
                    "dentist": false
                },
                "sortBy": {}
            },
            payParams: {
                startDate: this.state.startDate,
                endDate: moment(this.state.endDate).endOf('month').format('YYYY-MM-DD'),
                abbr: false,
                "filters": {
                    "dentistType": 2,
                    "years": moment(this.state.startDate).format('YYYY'),
                    "months": [moment(this.state.endDate).format('MM')],
                    "keyword": "",
                    "dentist": false
                },
                "sortBy": {},
                lock: {
                    action: null
                }
            },
            filters: {
                archive: false,
                status: false,
                dentist: false,
                startDate: this.state.startDate,
                endDate: moment(this.state.endDate).endOf('month').format('YYYY-MM-DD'),
                years: moment(this.state.startDate).format('YYYY'),
                months: [moment(this.state.startDate).format('MM')]
            },
            parameters: {
                startDate: this.state.startDate,
                endDate: moment(this.state.endDate).endOf('month').format('YYYY-MM-DD'),
                abbr: false,
                userId: []
            }
        }

    }

    toggleTable = (tableToShow) => {
        this.setState({ table: tableToShow })
    }

    getPracticesData = (doctorSelected) => {
        this.props.dispatch(getPracticeList(doctorSelected))
            .then(doctors => {
                if (!this.props.match.params.month || !this.props.match.params.year) {
                    const urlSplits = this.props.match.url.split('/');
                    this.props.dispatch(push(`/payandreports/${urlSplits[2]}/${moment(this.state.startDate).format('MM')}/${moment(this.state.endDate).format('YYYY')}`));
                }
                let practiceOptions = [{ key: 'none', value: null, text: 'All' }]
                let practiceAbbr = {}
                if (doctors && doctors.length) {
                    doctors.forEach(item => {
                        practiceAbbr[item.practice.toLowerCase()] = item.practiceabbr
                        // Value is the DB name so it compares against the practice keys used in the report data.
                        practiceOptions.push({ text: item.practice, value: item.practiceDBName || item.practice, key: item.id.toString() });
                    })
                }
                this.setState({ practiceAbbr: practiceAbbr, practiceOptions: practiceOptions });
            });
    }

    getMoreDoctorDetails = (ABBR) => {
        const { user } = this.props;
        if (!user) return null;

        const doctorList = this.dynamicDentistList(dentistTypes, 'allDentistListArray');
        return doctorList.find(f => f.abbr === ABBR.toLowerCase()) || null;
    }

    getDoctorDetails = (abbr) => {
        const { user } = this.props;
        if (!user) return null;

        const doctorList = this.dynamicDentistList(dentistTypes, 'dentistArray');
        return doctorList.find(f => f.abbr === abbr?.toLowerCase()) || null;
    }

    fetchRegions = () => {
        const { dispatch } = this.props;
        dispatch(getRegionList())
            .then(res => {
                this.setState({ regionList: res.regions, regionPractices: res.regionPractices })
            })
            .catch(err => {
                console.log('Found error on get region list', err);
            });
    }

    fetchSupportUsersList = () => {
        this.props.dispatch(getSupportUsersList())
            .then(list => {
                const supportUserOptions = [
                    { key: 'all', value: 'all', text: 'All' },
                    { key: '__not_defined__', value: '__not_defined__', text: 'Not Defined' },
                    ...(list || []).map(item => ({
                        key: item.id,
                        value: item.id,
                        text: `${item.firstName} ${item.lastName}`
                    }))
                ];
                this.setState({ supportUserOptions });
            })
            .catch(err => console.log('Found error on get getSupportUsersList', err));
    }

    getPracticeListOption = (regionList = []) => [
        { key: '0', value: null, text: 'All' },
        ...regionList.map(item => ({ text: item.name, value: item.id, key: item.id }))
    ];

    getBrandForDoctor = (practiceString) => {
        const { practiceListArray = [] } = this.props;
        return (practiceString || '').split(',')
            .map(p => practiceListArray.find(f => f.practice === p.trim())?.UdaPracticeInfos?.[0]?.brand)
            .filter(Boolean);
    }

    getRegionForSinglePractice = (practiceName) => {
        const { regionPractices = {} } = this.state;
        const name = practiceName?.toLowerCase();
        return Object.keys(regionPractices).filter(id => regionPractices[id].includes(name));
    }

    // Canonical lowercase DB-name key for a practice key found in the report data (the key is normally
    // practiceDBName, but can be the display name). Same identity as the Practice filter option values.
    getPracticeFilterKey = (practiceKey) => {
        const { practiceListArray = [] } = this.props;
        const lower = (practiceKey || '').toLowerCase();
        const entry = (practiceListArray || []).find(f =>
            (f.practiceDBName || '').toLowerCase() === lower || (f.practice || '').toLowerCase() === lower);
        return (entry?.practiceDBName || entry?.practice || practiceKey || '').toLowerCase();
    }

    // Set of canonical practice keys for the selected region(s); null when no region filter is set.
    getRegionFilterKeys = (regionFilter) => {
        const regionIds = toArray(regionFilter);
        if (!regionIds) return null;
        const { practiceListArray = [] } = this.props;
        const keys = new Set();
        (practiceListArray || []).forEach(p => {
            const info = Array.isArray(p.UdaPracticeInfos) ? p.UdaPracticeInfos[0] : p.UdaPracticeInfos;
            if (regionIds.some(r => String(r) === String(info?.regionId))) {
                keys.add((p.practiceDBName || p.practice || '').toLowerCase());
            }
        });
        return keys;
    }

    getRTODetails = (doctorName, practiceName) => {
        const { timeOffRequestData } = this.props;
        doctorName = doctorName.replace('Dr. ', '').replace(', RDH', '')
        let rtoApproved = 0;
        let rtoForced = 0;
        timeOffRequestData.length && timeOffRequestData.forEach(row => {
            if (row.requestType === 'forced' && row.doctorName === doctorName && row.practice === practiceName) {
                rtoForced += row.days;
            }
            if (row.requestType === 'requested' && row.doctorName === doctorName && row.practice === practiceName) {
                rtoApproved += row.days;
            }
        });
        return { rtoForced, rtoApproved };
    }

    getPracticeRampDates = (practiceName) => {
        const { practiceList } = this.props
        const found = practiceList.filter(f => f.practiceName === practiceName);
        if (found.length) {
            if (found[0].rampStartDate && found[0].rampEndDate) {
                found[0].rampStartDate = moment(found[0].rampStartDate).format('YYYY-MM-DD')
                found[0].rampEndDate = moment(found[0].rampEndDate).format('YYYY-MM-DD')
            }
            return (found[0]);
        } else {
            return 0;
        }
    }

    getPracticeName = (practiceDbName) => {
        const { practiceListArray = [] } = this.props;
        return practiceListArray.find(f => f.practiceDBName === practiceDbName || f.practice.toLowerCase() === practiceDbName)?.practice || null;
    }

    getNumberOfScheduledDays = (abbr, practice) => {
        const { drScheduleDays } = this.props;
        if (drScheduleDays) {
            abbr = abbr ? abbr.toLowerCase() : abbr
            const practiceArray = practice ? practice.toLowerCase().split(', ') : [];
            const scheduledDays = this.calculateScheduledDays();
            const found = scheduledDays.filter(f => (practiceArray.includes(f.practice)) && f.abbr === abbr);
            return found.reduce((total, obj) => obj.days + total, 0)
        } else {
            return 0
        }
    }


    getNumberOfWorkedDays = (abbr, practice) => {
        const { drScheduleDays } = this.props;
        if (drScheduleDays) {
            abbr = abbr ? abbr.toLowerCase() : abbr
            const practiceArray = practice ? practice.split(', ') : [];
            const workDays = this.calculateWorkDays();
            const found = workDays.filter(f => practiceArray.includes(f.practice) && f.abbr === abbr);
            return found.reduce((total, obj) => obj.days + total, 0)

        } else {
            return 0
        }
    }

    navigateNextPrev = (direction, currentStartDate,) => {
        this.setState({
            load: true, expandableColumn: null,
            expandableRowLevel2: null
        });
        const { dispatch } = this.props;

        let resultStartDate, resultEndDate;
        if (direction === 'left') {
            resultStartDate = moment(currentStartDate).subtract(1, 'months').format('YYYY-MM-DD');
            resultEndDate = moment(resultStartDate).endOf('month').format('YYYY-MM-DD')
        }

        if (direction === 'right') {
            resultStartDate = moment(currentStartDate).add(1, 'months').format('YYYY-MM-DD');
            resultEndDate = moment(resultStartDate).endOf('month').format('YYYY-MM-DD')

        }
        // update displayed month immediately so child components render with the new date
        // (prevents transient renders that use stale startDate and may show unfiltered rows)
        this.setState({ startDate: resultStartDate, endDate: resultEndDate });

        const urlSplits = this.props.match.url.split('/');
        dispatch(push(`/payandreports/${urlSplits[2]}/${moment(resultStartDate).format('MM')}/${moment(resultStartDate).format('YYYY')}`));


        let scheduleParams = {
            "filters": {
                "dentistType": 2,
                "years": moment(resultStartDate).format('YYYY'),
                "months": [moment(resultStartDate).format('MM')],
                "keyword": "",
                "dentist": false
            },
            "sortBy": {}
        }

        let payParams = {
            startDate: resultStartDate,
            endDate: resultEndDate,
            abbr: false,
            "filters": {
                "dentistType": 2,
                "years": moment(resultStartDate).format('YYYY'),
                "months": [moment(resultStartDate).format('MM')],
                "keyword": "",
                "dentist": false
            },
            "sortBy": {},
            lock: {
                action: null
            }
        }

        let params = {
            startDate: resultStartDate,
            endDate: resultEndDate,
            abbr: false,
            userId: []
        }
        const filters = payParams.filters

        this.fetchData(payParams, scheduleParams, filters, params, resultStartDate)

    }


    calculateBCare = (care, adjustment, writeOff, careFraction) => {
        return careFraction * (care - writeOff + adjustment) * 0.01;
    }


    getDoctorFullName = (ABBR) => {
        const abbr = ABBR?.startsWith('*') ? ABBR.split('&')[1] : ABBR;
        const details = this.getDoctorDetails(abbr);

        if (!details) return abbr;

        const { firstName, lastName } = details;
        return abbr?.startsWith('HYG')
            ? `${firstName} ${lastName}, RDH`
            : `Dr. ${firstName} ${lastName}`;
    }

    getDoctorAdjValue = (ABBR) => {
        const details = this.getDoctorDetails(ABBR) ? this.getDoctorDetails(ABBR) : ''

        if (details) {
            return details.prodAdjWo
        } else {
            return 0
        }
    }

    getPracticeDoctors = (data) => {
        let doctors = []
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                let abbr = ABBR;
                let details;
                if (ABBR && ABBR.substring(0, 1) === '*') {
                    abbr = ABBR.split('&')[1];
                }
                details = this.getDoctorDetails(abbr) ? this.getDoctorDetails(abbr) : ''
                const drName = 'Dr. ' + details.firstName + ' ' + details.lastName
                if (details) {
                    doctors.push(drName)
                } else {
                    doctors.push(data[ABBR].doctorNameFromProvider ? data[ABBR].doctorNameFromProvider + "#" : abbr)
                }
            })
        }
        return doctors.join(', ')
    }

    getPracticeABBRs = (data) => {
        let doctors = []
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                doctors.push(ABBR)
            })
            doctors = doctors.sort()
        }
        return doctors.join(', ')
    }

    getPracticeDoctorIsActiveStatuses = (data) => {
        let statuses = [];

        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                const isActive = this.getMoreDoctorDetails(ABBR) ? (this.getMoreDoctorDetails(ABBR).isActive ? 'active' : '') : '';
                statuses.push(isActive)
            })
            statuses = statuses.sort()
        }
        return statuses
    }

    getPracticeDoctorRole = (data) => {
        let roles = [];


        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                let userRole = '';
                const doctorUdrUsersPermissionsObj = this.getMoreDoctorDetails(ABBR) ? (this.getMoreDoctorDetails(ABBR).UdrUsersPermissions ? this.getMoreDoctorDetails(ABBR).UdrUsersPermissions : null) : null;
                if (doctorUdrUsersPermissionsObj !== null) {
                    userRole = doctorUdrUsersPermissionsObj[0] ? doctorUdrUsersPermissionsObj[0].UdrPermission ? doctorUdrUsersPermissionsObj[0].UdrPermission.role ? doctorUdrUsersPermissionsObj[0].UdrPermission.role : '' : '' : '';
                }
                roles.push('' + userRole + '')
            })
            roles = roles.sort()
        }
        return roles
    }

    getPracticeDoctorIds = (data) => {
        let doctors = []
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                const doctorId = this.getDoctorDetails(ABBR) ? this.getDoctorDetails(ABBR).doctorId : ''
                doctors.push(doctorId)
            })
            doctors = doctors.sort()
        }
        return doctors
    }

    getPracticeDoctorContractTypes = (data) => {
        let doctors = []
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                const contractName = this.getDoctorDetails(ABBR) ? this.getDoctorDetails(ABBR).contractName : ''
                doctors.push(contractName)
            })
            doctors = doctors.sort()
        }
        return doctors
    }

    getDoctorsPractices = (data, practiceDatabaseName) => {
        let practices = []
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((practice) => {
                practices.push(practiceDatabaseName ? practice : this.getPracticeName(practice))
            })
        }
        return practices.join(', ')
    }

    onSaveProviderPayOverride = async (payload) => {
        await this.props.dispatch(saveProviderPayOverride({ ...payload, userId: this.props.user?.id }));
    }

    onDeleteProviderPayOverride = async (id, payMonth) => {
        await this.props.dispatch(deleteProviderPayOverride(id, payMonth));
    }

    onDeleteProviderPayOverrideByKey = async (abbr, practiceDbName, payMonth) => {
        await this.props.dispatch(deleteProviderPayOverrideByKey(abbr, practiceDbName, payMonth));
    }

    getPracticeProductionPay = (data, practice) => {
        let practiceProductionPay = 0;
        if (data && Object.keys(data)) {
            Object.keys(data).forEach((ABBR) => {
                const adj = this.getDoctorAdjustment(ABBR, practice);
                const wo = this.getDoctorWriteOff(ABBR, practice);
                const care = data[ABBR].price;
                const careAdjWo = this.getDoctorAdjValue(ABBR);
                const doctorBCare = this.calculateBCare(care, adj, wo, careAdjWo);
                const payRateOverBase = this.getDoctorDetails(ABBR) ? this.getDoctorDetails(ABBR).payOverBase : 0;
                const doctorProductionPay = doctorBCare * payRateOverBase / 100;
                practiceProductionPay = practiceProductionPay + doctorProductionPay;
            })
        }
        return practiceProductionPay;
    }

    generateExpandableTableDataForPractice = () => {
        const { billingData } = this.props
        if (billingData && billingData.groupedByPracticeByDoctorAbbr) {
            let tableData = []
            const production = billingData.groupedByPracticeByDoctorAbbr
            Object.keys(production).forEach((practice) => {

                if (!(practice === "" || practice === "orderByDate" || practice === 'reportData' || practice === 'price')) {
                    const practiceName = this.getPracticeName(practice);
                    const financialNotesTotal = production[practice].financialNotes;
                    const practiceBCare = production[practice].practiceBCare
                    const percentageOfBillable = (procBasedPay / practiceBCare) * 100 ? (procBasedPay / practiceBCare) * 100 : 0;
                    const rampStartDate = this.getPracticeRampDates(practiceName).rampStartDate;
                    const rampEndDate = this.getPracticeRampDates(practiceName).rampEndDate;
                    const procBasedPay = percentageOfBillable !== null ? this.getPracticeProductionPay(production[practice].data, practice) : 0;
                    const tableRow = {
                        practiceName,
                        region: this.getRegionForSinglePractice(this.getPracticeName(practice)),
                        brand: this.getBrandForDoctor(this.getPracticeName(practice)),
                        practiceDoctorIds: this.getPracticeDoctorIds(production[practice].data),
                        practiceDoctorContractNames: this.getPracticeDoctorContractTypes(production[practice].data),
                        practiceDoctorIsActiveStatuses: this.getPracticeDoctorIsActiveStatuses(production[practice].data),
                        roles: this.getPracticeDoctorRole(production[practice].data),
                        data: production[practice].data,
                        practiceDoctors: this.getPracticeDoctors(production[practice].data),
                        practiceABBRs: this.getPracticeABBRs(production[practice].data),
                        adjustment: production[practice].adjustment,
                        writeOff: production[practice].writeOff,
                        practice: practice,
                        patientVisits: production[practice].patientVisits,
                        care: production[practice].price ? production[practice].price : 0,
                        procBasedPay: procBasedPay,
                        percentageOfBillable: percentageOfBillable,
                        bCare: practiceBCare,
                        rampStartDate,
                        rampEndDate,
                        financialNotesTotal
                    }
                    tableData.push(tableRow)
                }
            });
            tableData = _.sortBy(tableData, ['percentageOfBillable'], ['asc']).reverse();
            return tableData;
        }
    }

    generateContractTableData = (abbr) => {
        const { billingData } = this.props
        if (billingData && billingData.groupByDoctorByPractice) {
            let tableData = []

            const production = billingData.groupByDoctorByPractice;
            const docData = production[abbr].data;

            if (docData && Object.keys(docData)) {
                Object.keys(docData).forEach(practice => {
                    const practiceData = docData[practice].data
                    if (practiceData && Object.keys(practiceData)) {
                        Object.keys(practiceData).forEach(day => {
                            const tableRow = {
                                day: day,
                                practice: practice,
                            }
                            tableData.push(tableRow)
                        });
                    }
                })
            }
            tableData = _.sortBy(tableData, ['day']);
            return tableData;
        }
    }

    generateExpandableTableDataForDentists = () => {

        // TODO DO not use this method it is not upto date!!!!!
        // we Do not Calculate pay from the front end, everthing must come form the back end
        const { billingData } = this.props
        if (billingData && billingData.groupByDoctorByPractice) {
            const { timeOffRequestData } = this.props
            let tableData = []

            const production = billingData.groupByDoctorByPractice

            Object.keys(production).forEach((doctor) => {
                let bonusPay = 0;
                let basePay = 0
                const contractType = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).contractName : null
                const dentistWorkTimeType = this.getMoreDoctorDetails(doctor) ? this.getMoreDoctorDetails(doctor).dentistWorkTimeType : null
                const isActive = this.getMoreDoctorDetails(doctor) ? ((this.getMoreDoctorDetails(doctor).isActive) ? 'active' : 'inActive') : 'inActive';
                const payRateOverBase = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).payOverBase : 0
                const bCare = this.calculateBCare(production[doctor].price, this.getDoctorAdjustmentInverse(doctor), this.getDoctorWriteOffInverse(doctor), this.getDoctorAdjValue(doctor));

                const numberOfDaysWorked = this.getNumberOfWorkedDays(doctor, this.getDoctorsPractices(production[doctor].data, 'true'))
                let rawMonthlyBasePay = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).monthlyBasePay : 0
                const monthlyBaseWorkDays = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).monthlyBaseWorkDays : 0
                const rawMonthlyBaseProduction = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).monthlyBaseProduction : 0
                const doctorName = this.getDoctorDetails(doctor) ? this.getDoctorDetails(doctor).firstName + ' ' + this.getDoctorDetails(doctor).lastName : null
                const numberOfScheduledDays = this.getNumberOfScheduledDays(doctor, this.getDoctorsPractices(production[doctor].data))

                let monthlyBaseProduction, monthlyBasePay;


                if (contractType.includes('Greater Of')) {
                    basePay = (bCare * payRateOverBase / 100).toFixed(2);
                }
                if (contractType === 'GOX' || contractType === 'GOZ' || contractType === 'GOX w/HYN') {
                    basePay = (bCare * payRateOverBase / 100).toFixed(2);
                }
                if (contractType === 'Sum Of' || contractType === 'Sum Of w/HYN') {
                    if (monthlyBaseWorkDays <= numberOfScheduledDays) {
                        monthlyBasePay = rawMonthlyBasePay
                        monthlyBaseProduction = rawMonthlyBaseProduction

                        const RTODays = timeOffRequestData.length ? timeOffRequestData.filter(row => row.requestType === 'requested' && row.doctorName === doctorName).length : 0
                        if ((numberOfScheduledDays - RTODays) < monthlyBaseWorkDays) {
                            monthlyBasePay = rawMonthlyBasePay * (numberOfScheduledDays - RTODays) / monthlyBaseWorkDays
                            monthlyBaseProduction = rawMonthlyBaseProduction * (numberOfScheduledDays - RTODays) / monthlyBaseWorkDays
                        }
                    }

                    if (monthlyBaseWorkDays > numberOfScheduledDays) {
                        monthlyBasePay = rawMonthlyBasePay * (numberOfScheduledDays / monthlyBaseWorkDays)
                        monthlyBaseProduction = rawMonthlyBaseProduction * (numberOfScheduledDays / monthlyBaseWorkDays)
                        const RTODays = timeOffRequestData.length ? timeOffRequestData.filter(row => row.requestType === 'requested' && row.doctorName === doctorName).length : 0
                        if (RTODays > 0) {
                            monthlyBasePay = rawMonthlyBasePay * (numberOfScheduledDays - RTODays) / monthlyBaseWorkDays
                            monthlyBaseProduction = rawMonthlyBaseProduction * (numberOfScheduledDays - RTODays) / monthlyBaseWorkDays
                        }
                    }

                    bonusPay = bCare > monthlyBaseProduction ? (bCare - monthlyBaseProduction) * payRateOverBase * 0.01 : 0
                    basePay = monthlyBasePay * (numberOfDaysWorked / numberOfScheduledDays)

                }
                let procBasedPay = basePay + bonusPay
                const percentageOfBillable = (contractType.includes('Greater Of') || contractType.includes('GOX') || contractType === 'GOZ' || contractType.includes('Sum Of')) ? (100 * procBasedPay / bCare).toFixed(2) : 0;
                const tableRow = {
                    ABBR: doctor,
                    doctorId: this.getDoctorId(doctor),
                    data: production[doctor].data,
                    doctorPractices: production[doctor].doctorPracticesArray ? (production[doctor].doctorPracticesArray).join(', ') : '',
                    doctorPracticesArray: production[doctor].doctorPracticesArray,
                    region: production[doctor].region,
                    brand: production[doctor].brand,
                    adjustment: production[doctor].adjustmentPrice,
                    writeOff: production[doctor].writeOffPrice,
                    patientVisits: production[doctor].patientVisits,
                    doctorName: doctor,
                    contractType: contractType,
                    isActive: isActive,
                    lockStatus: production[doctor].lockStatus,
                    dentistWorkTimeType: dentistWorkTimeType,
                    price: production[doctor].price,
                    careFraction: this.getDoctorAdjValue(doctor),
                    bCare: bCare,
                    basePay,
                    bonusPay,
                    numberOfDaysWorked,
                    numberOfScheduledDays,
                    procBasedPay,
                    percentageOfBillable: percentageOfBillable
                }
                tableData.push(tableRow)
            })
            tableData = _.sortBy(tableData, ['percentageOfBillable'], ['asc']).reverse();
            return tableData;
        }
    }

    dynamicDentistList = (dentistTypes, listName) => {
        let allDentistListArray = [];
        let dentistOptions = [];
        let dentistAbbrObj = {};
        let dentistList = [];
        let dentistArray = [];

        const { user } = this.props

        if (user && user.scheduleDoctors && Object.keys(user.scheduleDoctors).length) {
            Object.keys(user.scheduleDoctors).forEach(id => {
                const drItem = user.scheduleDoctors[id];
                if (drItem.abbr) {
                    drItem.abbr = (drItem.abbr).toLowerCase()
                }
                allDentistListArray.push(drItem)
            });
        }

        if (user && dentistTypes && dentistTypes.length > 0) {
            // A provider can hold permissions under more than one of dentistTypes, so
            // merge/dedupe across them by doctorId rather than processing each role separately.
            mergeDrListByRoles(user.drList, dentistTypes, (drItem) => drItem.doctorId).forEach(({abbr, drItem}) => {
                dentistAbbrObj[drItem['doctorId']] = drItem['abbr'] ? drItem['abbr'].toLowerCase() : null
                dentistList[drItem['doctorId']] = drItem
                const customStyle = (drItem['contractName'] === 'Sum Of' || drItem['contractName'] === 'Sum Of w/HYN')
                    ? { background: 'primary', color: '#d67d38' } : drItem['contractName'] === 'Greater Of'
                        ? { background: '#1a89a7' } : drItem['contractName'] === 'GOX'
                            ? { background: 'green' } : drItem['contractName'] === 'GOZ'
                                ? { background: 'purple' } : drItem['contractName'] === 'Hygienist Incentive' || drItem['contractName'] === 'UKG HYN'
                                    ? { background: 'primary', color: 'black' } : drItem['contractName'] === 'Greater Of w/HYN'
                                        ? { background: '#07036B', color: '#ffffff' } : drItem['contractName'] === 'GOX w/HYN'
                                            ? { background: '#5FE47F', color: '#black' } : { background: 'grey' };
                if ((drItem['firstName'] !== '' || drItem['lastName'] !== '') && drItem.role !== 'Admin' && abbr !== 'null') {
                    dentistOptions.push({
                        key: drItem['doctorId'],
                        value: drItem['doctorId'],
                        text: `${drItem['firstName']} ${drItem['lastName']}(${abbr ? abbr : ""})`,
                        title: drItem['lastName'],
                        style: customStyle
                    });
                }
                if (drItem.abbr) {
                    drItem.abbr = (drItem.abbr).toLowerCase()
                }
                dentistArray.push(drItem);
            })
        }

        dentistOptions = _.sortBy(dentistOptions, ['title']);
        dentistOptions.unshift({ key: 'All', value: null, text: 'All' });


        dentistList = { dentistOptions, dentistAbbrObj, dentistList, allDentistListArray, dentistArray };

        return dentistList[listName]

    }

    calculateWorkDays = () => {
        let workDaysRecords = [];
        const { drScheduleDays: { bcareData } } = this.props

        if (bcareData && Object.keys(bcareData).length) {
            Object.keys(bcareData).forEach((value) => {
                let practiceData = bcareData[value]
                if (practiceData && Object.keys(bcareData)) {
                    Object.keys(practiceData).forEach((p) => {
                        workDaysRecords.push({ abbr: value, practice: p, days: practiceData[p] });
                    })
                }
            })
        }
        return workDaysRecords;
    }

    getContractDetails = (ABBR, doctorId, contractType, dentistWorkTimeType, userId, GoxNonBillableCare, isProdMove) => {
        // [V2-KEEP] S3 page: PPO / MCO / explanation / tier tabs load first. No-op on v1.
        withProviderDetail(this.props.loadProviderDetail, ABBR, () => {
            this.setState({ GreaterOfContractModal: true, detailAbbr: ABBR, doctorId: doctorId, contractType: contractType, dentistWorkTimeType: dentistWorkTimeType, docUserId: userId, GoxNonBillableCare: GoxNonBillableCare, isProdMove: isProdMove })
        })
    }
    closeContractDetailsModal = () => this.setState({ GreaterOfContractModal: false })

    getAbbr = (doctorID) => {
        const dentistAbbrObj = this.dynamicDentistList(dentistTypes, 'allDentistListArray')
        const found = dentistAbbrObj.filter(f => (parseInt(f.id)) === parseInt(doctorID));
        if (found.length) {
            return (found[0].abbr);
        } else {
            return null;
        }
    }

    getDoctorId = (abbr) => {
        const dentistAbbrObj = this.dynamicDentistList(dentistTypes, 'allDentistListArray')
        const found = dentistAbbrObj.filter(f => (f.abbr === abbr.toLowerCase()));
        if (found.length) {
            return (parseInt(found[0].id));
        } else {
            return null;
        }
    }

    calculateScheduledDays = () => {
        let scheduleDaysRecords = [];
        const { scheduleData } = this.props.drScheduleDays

        if (scheduleData && Object.keys(scheduleData).length) {
            Object.keys(scheduleData).forEach((doctorID) => {
                let doctorData = scheduleData[doctorID]
                const abbr = this.getAbbr(doctorID)
                if (doctorData && Object.keys(doctorData).length) {
                    Object.keys(doctorData).forEach((p) => {
                        scheduleDaysRecords.push({ id: doctorID, abbr: abbr, practice: p, days: doctorData[p] })
                    })
                }
            });

        }
        return scheduleDaysRecords
    }

    getDoctorAdjustmentInverse = (doctor) => {
        const { billingData } = this.props
        const adjustments = billingData.adjustmentGroupByDentistByPractice

        if (adjustments[doctor]) {
            return adjustments[doctor].price
        } else {
            return 0
        }
    }
    getFinancialNote = (doctor) => {
        const { billingData } = this.props
        const byDoctors = billingData.groupByDoctorByPractice
        const doctorsData = byDoctors.filter(d => d.ABBR == doctor)
        return doctorsData
    }

    getDoctorWriteOffInverse = (doctor) => {
        const { billingData } = this.props
        const writeOff = billingData.writeOffGroupByDentistByPractice

        if (writeOff[doctor]) {
            return writeOff[doctor].price
        } else {
            return 0
        }
    }


    getDoctorAdjustment = (ABBR, practice) => {
        const { billingData } = this.props
        const adjustments = billingData.adjustmentByPracticeByDoctorAbbr

        if (this.getPracticeName(practice) && adjustments[practice] && adjustments[practice].data && adjustments[practice].data[ABBR]) {
            return adjustments[practice].data[ABBR].price
        } else {
            return 0
        }

    }

    getDoctorWriteOff = (ABBR, practice) => {
        const { billingData } = this.props
        const writeOffs = billingData.writeoffByPracticeByDoctorAbbr
        if (this.getPracticeName(practice) && writeOffs[practice] && writeOffs[practice].data && writeOffs[practice].data[ABBR]) {

            return writeOffs[practice].data[ABBR].price
        } else {
            return 0
        }
    }

    handleShowHideFilters = () => {
        this.setState({ showFilters: !this.state.showFilters })
    }

    toggleRampSetupModal = (currentState) => {
        if (currentState) {
            let clearRampState = {
                id: 0,
                patientVisits: null,
                productionThreshold: null,
            };
            this.setState({ rampSetupForm: clearRampState });
        }
        this.setState({ rampSetupModal: !currentState })
    }

    onChangeFilter = (e, element) => {
        const { filters } = this.state;
        const updatedFilters = { ...filters };

        if (element.value && element.value === 'reset') {
            element.value = initialFilters[element.name];
        }

        switch (element.name) {
            case 'role': {
                this.setState({ role: element.value })
                break
            }
            case 'contractType':
                updatedFilters.tedFilter = false;
                this.setState({ contractType: element.value })
                break

            case 'brandName':
                this.setState({ brandName: element.value.join(';') })
                break

            case 'isActive':
                this.setState({ isActive: element.value })
                break

            case 'practiceName':
                this.setState({ practiceName: element.value })
                break

            case 'region':
                this.setState({ region: element.value })
                break

            case 'dentist':
                this.setState({ dentist: element.value })
                break

            case 'rampDate':
                this.setState({ rampDate: element.value });
                break;

            default:
                break;
        }

        updatedFilters[element.name] = element.value;
        this.setState({ filters: { ...updatedFilters } })
    }

    filterRampDateData = (data, rampFilterOption) => {
        const rampRecords = [];
        data.forEach(item => {
            if (item) {
                if ((item.rampStartDate !== null) && rampFilterOption === true) {
                    const itemRampStartDate = moment(item.rampStartDate).format('YYYY-MM-DD');
                    if (item.rampEndDate !== null) {
                        const itemRampEndDate = moment(item.rampEndDate).format('YYYY-MM-DD');
                        const currentDate = moment().format("YYYY-MM-DD");
                        const result = moment(currentDate).isBetween(itemRampStartDate, itemRampEndDate);
                        if (result) {
                            rampRecords.push(item);
                        }
                    } else {
                        rampRecords.push(item);
                    }
                } if ((item.rampStartDate === null) && rampFilterOption === false) {
                    rampRecords.push(item);
                }
            }
        });
        return rampRecords;
    };

    filterTableData = (data) => {
        let filteredData = data;
        let filters = this.state.filters;

        if (filters.brandName && (filters.brandName).length > 0 && !(filters.brandName).includes('All')) {
            filteredData = filteredData.filter(item => ((item.brand).filter(value => (filters.brandName).includes(value))).length > 0)
        }

        if (filters.dentist) {
            filteredData = filteredData.filter(item => (item.practiceDoctorIds).indexOf(filters.dentist) > -1)
        }

        if (filters.practiceName) {
            const selectedKey = String(filters.practiceName).toLowerCase();
            filteredData = filteredData.filter(item => this.getPracticeFilterKey(item.practice) === selectedKey)
        }

        if (filters.contractType && filters.contractType.length > 0) {
            filteredData = filteredData.filter(item =>
                filters.contractType.some(type => item.practiceDoctorContractNames.includes(type))
            );
        }

        if (filters.role && filters.role.length > 0) {
            filteredData = filteredData.filter(item => filters.role.includes(item.role));
        }

        if (filters.region) {
            const regionKeys = this.getRegionFilterKeys(filters.region);
            filteredData = filteredData.filter(item => regionKeys.has(this.getPracticeFilterKey(item.practice)))
        }

        if (filters.isActive) {
            if (filters.isActive === isActive) {
                filteredData = filteredData.filter(item => (((item.practiceDoctorIsActiveStatuses).indexOf(filters.isActive) > -1) &&
                    (item.roles.some(element => {
                        return isActiveRoles.includes(element);
                    }))));
            } else {
                filteredData = filteredData.filter(item => (((item.practiceDoctorIsActiveStatuses).indexOf(isActive) !== 0) &&
                    (item.roles.some(element => {
                        return isActiveRoles.includes(element);
                    }))));
            }
        }

        if ((filters.rampDate === true) || (filters.rampDate === false)) {
            const rampEndRecords = this.filterRampDateData(filteredData, filters.rampDate);
            filteredData = rampEndRecords;
        }
        if ((filters.payType === true) || (filters.payType === false)) {
            filteredData = this.filterPayType(filteredData);
        }

        return filteredData;
    }

    filterPayType = (data) => {
        const { payType } = this.state.filters;
        if (payType === null || payType === undefined) return data;
        return data.filter(element => isProviderOverBase(element, payType));
    }


    getRampSetupData = () => {
        const { rampSetupList } = this.props
        let tableRows = []
        const values = []

        if (rampSetupList) {
            rampSetupList.forEach((item) => {
                if (!isNaN(item.reduced_practice_threshold)) {
                    values.push(item.reduced_practice_threshold)
                }
            })
            rampSetupList.forEach((item) => {
                if (item.Practice && item.Practice.practice) {
                    tableRows.push(
                        <tr>
                            <td>{item.Practice.practice}</td>
                            {values.map(r => {
                                return <td><input type="text" value={r} disabled /></td>
                            })}
                        </tr>
                    )
                }
            })
            return tableRows
        }
    }

    getDateAdjustment = (ABBR, practice, date) => {
        const adjustments = this.props.billingData.adjustmentByPracticeByDoctorAbbr
        if (this.getPracticeName(practice) && adjustments[practice] && adjustments[practice] && adjustments[practice].data && adjustments[practice] && adjustments[practice].data[ABBR] && adjustments[practice].data[ABBR].data[date]) {
            return (adjustments[practice].data[ABBR].data[date]).reduce((total, obj) => obj.AdjAmt + total, 0)
        } else {
            return 0
        }

    }

    expandRow = (rowId) => {
        const { expandableColumn } = this.state
        if (expandableColumn === rowId) {
            this.setState({ expandableColumn: null, expandableRowLevel2: null })
            return
        }

        // [V2-KEEP] S3 page: day procedures (Care hover) load first. No-op on v1.
        withProviderDetail(this.props.loadProviderDetail, rowId, () => {
            this.setState({ expandableColumn: rowId })
        })

    }

    expandRowLevelTwo = (rowId) => {
        const { expandableRowLevel2 } = this.state
        if (expandableRowLevel2 === rowId) {
            this.setState({ expandableRowLevel2: null })
            return
        }

        this.setState({ expandableRowLevel2: rowId })

    }

    getDateAdjustmentInverse = (ABBR, practice, date) => {
        const { billingData } = this.props;
        const adjustments = billingData.adjustmentGroupByDentistByPractice
        if (adjustments[ABBR] && adjustments[ABBR].data && adjustments[ABBR].data[practice] && adjustments[ABBR].data[practice].data[date]) {
            return (adjustments[ABBR].data[practice].data[date]).reduce((total, obj) => obj.AdjAmt + total, 0)
        } else {
            return 0
        }

    }

    getDateWriteOff = (ABBR, practice, date) => {
        const { billingData } = this.props;
        const writeOffs = billingData.writeoffByPracticeByDoctorAbbr
        if (this.getPracticeName(practice) && writeOffs[practice] && writeOffs[practice].data && writeOffs[practice].data[ABBR] && writeOffs[practice].data[ABBR].data[date]) {
            return (writeOffs[practice].data[ABBR].data[date]).reduce((total, obj) => obj.WriteOff + total, 0)
        } else {
            return 0
        }

    }

    getDateWriteOffInverse = (ABBR, practice, date) => {
        const { billingData } = this.props;
        const writeOffs = billingData.writeOffGroupByDentistByPractice
        if (writeOffs[ABBR] && writeOffs[ABBR].data && writeOffs[ABBR].data[practice] && writeOffs[ABBR].data[practice].data[date]) {
            return (writeOffs[ABBR].data[practice].data[date]).reduce((total, obj) => obj.WriteOff + total, 0)
        } else {
            return 0
        }

    }

    removeDuplicates = (array, property) => {
        const seen = new Set();
        return array.filter(object => {
            const isDuplicate = seen.has(object[property]);
            seen.add(object[property]);
            return !isDuplicate;
        })
    }

    showLockedProvidersModal = (item) => {
        this.setState({
            lockedProvidersModal: true,
            lockedProvidersModalData: item.abbr,
            selectedLock: item
        })
    }

    getDoctorList = () => {
        const { user } = this.props;
        if (user) {
            const doctorList = this.dynamicDentistList(dentistTypesOrtho, 'dentistArray');
            return this.getUniqueObjects(doctorList)
        }
        return [];
    }

    getUniqueObjects = (arrData) => {
        const uniqueIds = [];
        return arrData.filter(elem => {
            const isDuplicate = uniqueIds.includes(elem.userId);
            if (!isDuplicate) {
                uniqueIds.push(elem.userId);
                return true;
            }
            return false;
        });
    }


    hideHistoryModal = () => this.setState({ LockHistoryModal: false })

    hideLockedProvidersModal = () => this.setState({ lockedProvidersModal: false, lockedProvidersModalData: null });

    toggleActiveLock = (lockItem, other) => {
        const { startDate, endDate } = this.state
        const { dispatch } = this.props;
        dispatch(selectAndDeselectLock({ lockItem, other, scheduleDate: [startDate, endDate] }))
    }

    hideErrorModal = () => this.props.dispatch(hideErrorModal());

    getDoctorDetail = (doctor, doctorList) => {
        const provider = doctorList.find((item) => !isBlankNullOrUndefined(item.abbr) && item.abbr.toLowerCase() === doctor.toLowerCase());
        if (provider) {
            return provider;
        } else {
            return { firstName: '', lastName: '' };
        }
    }

    updateHeaderLabel = (value) => {
        if (this.state.headerLabel !== value)
            this.setState({ headerLabel: value })
    }

    resetFilter = () => {
        this.setState({
            filters: {
                dentist: null,
                region: null,
                practiceName: null,
                contractType: null,
                isActive: isActiveOptions[1].value,
                brandName: brands.map(brandOption => brandOption.value),
                role: udaRoleOptions[0].value,
                rampDate: rampDateOptions[0].value,
                daysType: null
            },
            rampDateFilter: false
        });
    }

    getPracticeById = (id) => {
        const { practiceListArray } = this.props
        const found = practiceListArray.filter(f => (f.id) === id);
        if (found.length) {
            return (found[0].practice);
        } else {
            return 'Not found';
        }
    }

    updateBasePerc = (value) => {
        if (this.state.basePercent !== value)
            this.setState({ basePercent: value })
    }

    // Computed on demand, right now, from whatever the table last rendered — not tracked
    // via a render-cycle callback, so opening the modal can never trigger a setState loop.
    openBaseAuditModal = () => {
        const rows = this.dentistsTableRef.current?.getBaseAuditRows?.() || [];
        this.setState({ baseAuditRows: rows, baseAuditModalOpen: true });
    }
    closeBaseAuditModal = () => this.setState({ baseAuditModalOpen: false })

    updateCustomContractPerc = (value) => {
        if (this.state.customContractPercent !== value)
            this.setState({ customContractPercent: value })
    }

    render() {
        const { startDate, endDate, load, loadingCrossReportTotals, GreaterOfContractModal, practiceOptions,
            regionList, table, expandableColumn, expandableRowLevel2, rampDateFilter,
            lockedProvidersModalData, selectedDoctors, selectedLock, sageAccounts, showFilters } = this.state
        const { billingData, user, doctorSchedule, drScheduleDays, timeOffRequestData, schedule, loadDataError, lockHistory } = this.props;
        const activeLock = lockHistory && lockHistory.length > 0 ? lockHistory.filter(iLock => iLock.lockStatus === true)[0] : []
        let dentistOptions = this.dynamicDentistList(dentistTypes, 'dentistOptions');
        dentistOptions = this.removeDuplicates(dentistOptions, 'key')
        let prodMovePractices = [];
        this.props.productionMove && this.props.productionMove.forEach((move) => {
            const prac = this.getPracticeById(move.practiceId);
            const objMove = {
                doctorsAbbr: [move.abbrFrom.toUpperCase(), move.abbrTo.toUpperCase()],
                practice: prac
            }
            prodMovePractices.push(objMove);
        });


        let regionListOptions = [];
        if (regionList)
            regionListOptions = this.getPracticeListOption(regionList);

        let isAdmin = false;
        let viewOnly = false
        if (user && user.isAdmin) {
            isAdmin = true
        }

        if (user && user.viewOnly) {
            viewOnly = true
        }
        let lockedProvidersModalList = [];
        if (lockedProvidersModalData && lockedProvidersModalData.length > 0) {
            const lockedProvidersArray = lockedProvidersModalData.split(',');
            let doctorList = [];
            let data = [];
            if (lockedProvidersArray.length) {
                doctorList = this.getDoctorList();
                data = lockedProvidersArray.map((provider) => {
                    const doctorDetail = this.getDoctorDetail(provider, doctorList);
                    return {
                        provider,
                        firstName: doctorDetail.firstName,
                        lastName: doctorDetail.lastName,
                        dentistId: doctorDetail.doctorId,
                        userId: doctorDetail.userId,
                        contractName: doctorDetail.contractName
                    }
                });
            }
            lockedProvidersModalList = data;
        }
        let doctorCount = 0;
        if (selectedDoctors.length > 0 && table === 'dentist') {
            const doctorList = this.getDoctorList().filter(item => item.contractName !== 'UKG HYN');
            const found = doctorList.filter(f => selectedDoctors.includes(f.abbr));
            doctorCount = found.length;
        }

        const noteCounts =
            billingData?.groupByDoctorByPractice?.reduce(
                (acc, row) => {
                    if (Array.isArray(row.financialNoteList)) {
                        row.financialNoteList.forEach(note => {
                            const fn = Number(note?.financialNotes);
                            const bc = Number(note?.bcare);

                            if (!Number.isNaN(fn) && fn !== 0) {
                                acc.financialNotes++;
                            }

                            if (!Number.isNaN(bc) && bc !== 0) {
                                acc.bcare++;
                            }
                        });
                    }
                    return acc;
                },
                { financialNotes: 0, bcare: 0 }
            ) || { financialNotes: 0, bcare: 0 };


        return (
            <div className="calendar-container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="float-left">
                            {this.props.title || 'CDP Reports'}
                            {table === 'dentist' && doctorCount > 0 ? `(${doctorCount} of ${this.state.headerLabel})` : `(${this.state.headerLabel})`}{!this.props.title && <HelpMark pageId="36" />}
                        </h2>
                        {this.props.saved && <ReportStatus
                            {...this.props}
                            onRefresh={this.onRefresh}
                            startDate={startDate}
                            reportParams={JSON.stringify(this.generateParameters(this.props.params, this.state.startDate).payParams)}
                            reportType="report"
                        />}
                    </div>
                </div>
                {
                    this.state.LockHistoryModal &&
                    <LockHistoryModal
                        hideHistoryModal={this.hideHistoryModal}
                        lockLogs={this.state.lockedDoctorsArry}
                        selectedLock={selectedLock}
                        hideLockedProvidersModal={this.hideLockedProvidersModal}
                        showLockedProvidersModal={this.showLockedProvidersModal}
                        lockedProvidersModal={this.state.lockedProvidersModal}
                        lockedProvidersModalData={lockedProvidersModalList}
                        toggleActiveLock={this.toggleActiveLock}
                        dynamicDentistList={this.dynamicDentistList}
                        user={user}
                        startDate={startDate}
                        endDate={endDate}
                        setLockProcessingFlag={this.setLockProcessingFlag}
                    />
                }

                {
                    loadDataError && <ErrorModal hideDetailsModal={this.hideErrorModal} errorMessage={loadDataError} />
                }

                <BaseStatusModal
                    open={this.state.baseAuditModalOpen}
                    onClose={this.closeBaseAuditModal}
                    rows={this.state.baseAuditRows}
                />

                <RampSetupModal
                    rampSetupModal={this.state.rampSetupModal}
                    toggleRampSetupModal={this.toggleRampSetupModal}
                    onChangeRampInput={this.onChangeRampInput}
                    getRampSetupData={this.getRampSetupData()}
                    rampSetupFormEdit={this.state.rampSetupFormEdit}
                    rampSetupForm={this.state.rampSetupForm}

                />

                {<GreaterOfContract
                    {...this.props}
                    productionData={this.generateExpandableTableDataForDentists}
                    open={GreaterOfContractModal}
                    closeContractDetailsModal={this.closeContractDetailsModal}
                    doctorABBR={this.state.detailAbbr}
                    doctorId={this.state.doctorId}
                    contractType={this.state.contractType}
                    dentistWorkTimeType={this.state.dentistWorkTimeType}
                    schedule={doctorSchedule}
                    generateContractTableData={this.generateContractTableData}
                    startDate={startDate}
                    endDate={endDate}
                    drScheduleDays={drScheduleDays}
                    billingData={billingData}
                    timeOffRequestData={timeOffRequestData}
                    nextPrev={this.navigateNextPrev}
                    getDoctorAdjValue={this.getDoctorAdjValue}
                    calculateBCare={this.calculateBCare}
                    getDateAdjustment={this.getDateAdjustment}
                    getDateWriteOff={this.getDateWriteOff}
                    docUserId={this.state.docUserId}
                    GoxNonBillableCare={this.state.GoxNonBillableCare}
                    isProdMove={this.state.isProdMove}
                />}
                {(load || loadingCrossReportTotals) && <Loading />}
                {(viewOnly || isAdmin) &&
                    <div className="ui card">
                        <div className="content">

                            <div className="cdp-reports-top-filters d-flex flex-wrap align-items-center">
                                <div className="cdp-month-navigator">
                                    <button
                                        className="cdp-month-navigator__arrow"
                                        onClick={() => this.navigateNextPrev('left', this.state.startDate)}
                                        aria-label="Previous month"
                                    >
                                        &#8249;
                                    </button>
                                    <span className="cdp-month-navigator__label">
                                        {moment(this.state.startDate).format('MMMM YYYY')}
                                    </span>
                                    <button
                                        className="cdp-month-navigator__arrow"
                                        onClick={() => this.navigateNextPrev('right', this.state.startDate)}
                                        aria-label="Next month"
                                    >
                                        &#8250;
                                    </button>
                                </div>
                                <Button
                                    basic
                                    size="small"
                                    className="mr-3"
                                    onClick={() => this.toggleRampSetupModal(this.state.rampSetupModal)}
                                >
                                    Ramp Setup
                                </Button>
                                {table === 'dentist' && (
                                    <div
                                        className="cdp-stat-badge cursorPointer"
                                        onClick={this.openBaseAuditModal}
                                        title="Click to see the Base / Over Base breakdown per provider"
                                    >
                                        <span className="cdp-stat-badge__label">Base Pay</span>
                                        <span className="cdp-stat-badge__value">{this.state.basePercent}%</span>
                                    </div>
                                )}
                                {table === 'dentist' && (
                                    <div className="cdp-stat-badge">
                                        <span className="cdp-stat-badge__label">Custom</span>
                                        <span className="cdp-stat-badge__value">{this.state.customContractPercent}%</span>
                                    </div>
                                )}
                                <Popup
                                    trigger={
                                        <Button icon="info circle orange" circular size="mini" className="ml-2" />
                                    }
                                    content={<Legend />}
                                    on="click"
                                    position="bottom right"
                                    wide="very"
                                />

                                {billingData && billingData.activeLockHistory && <Icon className="cdp-lock-icon" size="large" color="red" name='lock' />}
                                <div className="cdp-toolbar-right">
                                    {table === 'dentist' && billingData && billingData.groupByDoctorByPractice &&
                                        <>
                                            <div className="cdp-stat-badge">
                                                <span className="cdp-stat-badge__label">Fin Notes</span>
                                                <span className="cdp-stat-badge__value">{noteCounts.financialNotes}</span>
                                            </div>
                                            <div className="cdp-stat-badge">
                                                <span className="cdp-stat-badge__label">FinNote BCare</span>
                                                <span className="cdp-stat-badge__value">{noteCounts.bcare}</span>
                                            </div>
                                            <button
                                                className={`cdp-filter-toggle${showFilters ? ' cdp-filter-toggle--active' : ''}`}
                                                onClick={() => this.handleShowHideFilters()}
                                            >
                                                <Icon name='filter' />
                                                {showFilters ? 'Hide Filters' : 'Show Filters'}
                                            </button>
                                            <EarningSending
                                                {...this.props}
                                                type={'cdpReports'}
                                                startDate={startDate}
                                                endDate={endDate}
                                                selectedDoctors={this.state.selectedDoctors}
                                                payValidation={this.state.providerValidationRecords}
                                                sendToProviders={this.state.isProviderSet}
                                                payDataByProvider={billingData.groupByDoctorByPractice}
                                            />
                                        </>
                                    }
                                </div>
                            </div>
                            <div>

                                {table === 'dentist' && billingData && billingData.groupByDoctorByPractice &&
                                    <CdpReportsTableByDentists
                                        showFilters={showFilters}
                                        reportData={billingData.groupByDoctorByPractice}
                                        {...this.props}
                                        contractNameOptions={contractNameOptions}
                                        brandOptions={brands}
                                        {...this.state}
                                        handleSelectDoctor={this.handleSelectDoctor}
                                        handleSelectAll={this.handleSelectAll}
                                        setExcludedProviders={this.setExcludedProviders}
                                        excludeProvider={this.excludeProvider}
                                        undoLastExcludedProvider={this.undoLastExcludedProvider}
                                        getPracticeName={this.getPracticeName}
                                        getPracticeFilterKey={this.getPracticeFilterKey}
                                        getRegionFilterKeys={this.getRegionFilterKeys}
                                        sendReport={sendReport}
                                        sendFamilyReport={sendFamilyReport}
                                        getFamilyPatientDetails={getFamilyPatientDetails}
                                        getDateWriteOffInverse={this.getDateWriteOffInverse}
                                        getDateAdjustmentInverse={this.getDateAdjustmentInverse}
                                        calculateBCare={this.calculateBCare}
                                        getDoctorFullName={this.getDoctorFullName}
                                        getContractDetails={this.getContractDetails}
                                        getRTODetails={this.getRTODetails}
                                        dentistOptions={dentistOptions}
                                        regionListOptions={regionListOptions}
                                        regionListPractices={this.state.regionPractices}
                                        practiceOptions={practiceOptions}
                                        isActiveOptions={isActiveOptions}
                                        expandableColumn={expandableColumn}
                                        expandableRowLevel2={expandableRowLevel2}
                                        expandRow={this.expandRow}
                                        expandRowLevelTwo={this.expandRowLevelTwo}
                                        scheduleHours={schedule}
                                        onChangeFilter={this.onChangeFilter}
                                        rampDateFilter={rampDateFilter}
                                        updateHeaderLabel={this.updateHeaderLabel}
                                        resetFilter={this.resetFilter}
                                        rampDateOptions={rampDateOptions}
                                        activeLock={activeLock}
                                        startDate={startDate}
                                        endDate={endDate}
                                        prodMovePractices={prodMovePractices}
                                        ref={this.dentistsTableRef}
                                        updateBasePerc={this.updateBasePerc}
                                        updateCustomContractPerc={this.updateCustomContractPerc}
                                        collectionDentistData={billingData.collectionGroupByDentistByPractice}
                                        sageAccounts={sageAccounts}
                                        onSaveProviderPayOverride={this.onSaveProviderPayOverride}
                                        onDeleteProviderPayOverride={this.onDeleteProviderPayOverride}
                                        onDeleteProviderPayOverrideByKey={this.onDeleteProviderPayOverrideByKey}
                                    />}

                                {table === 'practice' && billingData && billingData.groupedByPracticeByDoctorAbbr &&
                                    <CdpReportsTableByPractice
                                        reportData={this.generateExpandableTableDataForPractice()}
                                        getDoctorAdjustment={this.getDoctorAdjustment}
                                        getDoctorWriteOff={this.getDoctorWriteOff}
                                        getDoctorFullName={this.getDoctorFullName}
                                        getDoctorAdjValue={this.getDoctorAdjValue}
                                        calculateBCare={this.calculateBCare}
                                        getNumberOfWorkedDays={this.getNumberOfWorkedDays}
                                        getNumberOfScheduledDays={this.getNumberOfScheduledDays}
                                        groupBy={this.groupBy}
                                        getDateAdjustment={this.getDateAdjustment}
                                        getDateWriteOff={this.getDateWriteOff}
                                        getContractDetails={this.getContractDetails}
                                        getRTODetails={this.getRTODetails}
                                        contractNameOptions={contractNameOptions}
                                        brandOptions={brands}
                                        dentistOptions={dentistOptions}
                                        regionListOptions={regionListOptions}
                                        practiceOptions={practiceOptions}
                                        udaRoleOptions={udaRoleOptions}
                                        isActiveOptions={isActiveOptions}
                                        expandableColumn={expandableColumn}
                                        expandableRowLevel2={expandableRowLevel2}
                                        expandRow={this.expandRow}
                                        expandRowLevelTwo={this.expandRowLevelTwo}
                                        filters={this.state.filters}
                                        scheduleHours={schedule}
                                        onChangeFilter={this.onChangeFilter}
                                        filterTableData={this.filterTableData}
                                        getCareFractionValue={this.getDoctorDetails}
                                        rampDateFilter={rampDateFilter}
                                        resetFilter={this.resetFilter}
                                        rampDateOptions={rampDateOptions}
                                        getPracticeDoctors={this.getPracticeDoctors}
                                        getFinancialNote={this.getFinancialNote}
                                        updateHeaderLabel={this.updateHeaderLabel}
                                        sendFamilyReport={sendFamilyReport}
                                        getFamilyPatientDetails={getFamilyPatientDetails}
                                    />}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default connect(
    state => ({
        user: state.get('auth').get('user'),
        drScheduleDays: state.get('timeoffRequests').get('drScheduleDays'),
        timeOffRequestData: state.get('payReports').get('timeOffRequestData'),
        billingData: state.get('payReports').get('billingData'),
        scheduleData: state.get('payReports').get('scheduleData'),
        practiceListArray: state.get('practices').get('practiceListArray'),
        practiceList: state.get('practices').get('practiceList'),
        rampSetupList: state.get('payReports').get('rampSetup'),
        loadDataError: state.get('payReports').get('loadDataError'),
        doctorSchedule: state.get('schedule').get('schedule'),
        schedule: state.get('schedule').get('scheduleMultiple'),
        params: state.get('payReports').get('params'),
        udrUserPermissions: state.get('payReports').get('udrUserPermissions'),

        isLoad: state.get('billing').get('isLoad'),
        isNextDaysLoad: state.get('billing').get('isNextDaysLoad'),
        loadErr: state.get('billing').get('loadErr'),
        loadErrFamily: state.get('billing').get('loadErrFamily'),
        familyData: state.get('billing').get('familyData'),
        aptResult: state.get('billing').get('familyData').aptResult,
        treatmentList: state.get('billing').get('familyData').treatmentList,
        commlog: state.get('billing').get('familyData').commlog,
        treatmentPlan: state.get('billing').get('familyData').treatmentPlan,
        isLoadFamily: state.get('billing').get('isLoadFamily'),
        nextDaysData: state.get('billing').get('nextDaysData'),
        lockHistory: state.get('payReports').get('lockHistory'),
        productionMove: state.get('payReports').get('productionMove'),
        providerPayOverrides: state.get('payReports').get('providerPayOverrides'),
    }))(CdpReports);

